import React from "react";

const SubmitButton = ({ text }) => {
    return <input type="submit" value={text} className="cursor-pointer shadow-1 red-bg text-white  rounded-2 py-3 my-2 w-32 font-bold mx-auto" />;
};

export default SubmitButton;
